export const NetworkContextName = 'NETWORK';
export const ACTIVE_NETWORK = 361;
export const token = '0x352E9437E5403fc580FE6dA999289D4696bF9b7a';
export const NFTMetadataStoreToken =
  '0xDc8cdB6D1Aa9FeCCE5E4d7F9875610255bd93571';
export const TestERC = '0xc18ABdb1DE2d453F90f92295351B30c1D900dbbc';
export const NFTRegistry = '0xA2A12A8883988808E3ef4d4bdDd16BE5aE800BCC';
export const Finalcontractaddress =
  '0x1f3De9cdB1D4eD10e8b7b3F21F282D84f7f54473';
